import React from 'react';
import { Component } from 'react';
import { InitialState } from '../data/initialState';
import { connect } from 'react-redux';
import Header from './Header';
import DriversLicenseBlock from '../contents/driverslicense/DriversLicense';

class DriverlicenseCont extends Component {
    acceptTerms(e) {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'form-interaction',
                interaction: 'driving-questions-complete',
                formType: 'Test Drive',
                engagementType: 'User Requested'
            });
        }

        this.props.handleSubmit(e);
    }

    render() {
        let { containerClass, updateValue, handleSubmit, buttonStatus, store } = this.props;
        const driverlicenseSection = (typeof window.tesla !== "undefined") ? window.tesla.App.strings['Test_Drive/All'].content.driverlicenseSection : {};

        return (
            <div className={"content-container driverlicense-container " + containerClass} style={{position: "absolute"}}>
                <Header 
                    title={driverlicenseSection.title}
                    paragraphs={[driverlicenseSection.title2]}
                />
                <DriversLicenseBlock
                    handleSubmit={handleSubmit}
                    store={store}
                    updateValue={updateValue} />
                <div className='btn-container'>
                    <button className="tds-btn tds-btn--blue" data-section="driverlicenseSection" onClick={this.acceptTerms.bind(this)} id="edit-submit-td-ajax" disabled={buttonStatus}>{driverlicenseSection.next}</button>
                </div>
            </div>
        );
    }
}

DriverlicenseCont.defaultProps = InitialState().driverlicenseSection

// Map Redux state to component props
function mapStateToProps(state) {
    var _state = state;

    return {
        containerClass: _state.driverlicenseSection.containerClass,
        buttonStatus: _state.driverlicenseSection.buttonStatus
    }
}

const DriverlicenseContainer = connect(
    mapStateToProps
)(DriverlicenseCont)

export default DriverlicenseContainer
